export enum ApproveOperationalPlanType {
    DEFAULT = 0,
    AGENT = 1,
    DISPATCH = 2,
    DISPATCH_SHIFT = 3
}